import { render, staticRenderFns } from "./ProgramSekolahMitra.vue?vue&type=template&id=53421870&"
import script from "./ProgramSekolahMitra.vue?vue&type=script&lang=js&"
export * from "./ProgramSekolahMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports